export default class BarcodePoolService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  // Admin
  generateBarcodePoolAdmin(args) {
    return this.axiosIns.post(this.serviceConfig.adminBarcodePoolGenerate, args);
  }

  getBarcodePoolStatus(args) {
    return this.axiosIns.get(this.serviceConfig.adminBarcodePool, { params: args });
  }

  purgeBarcodePool(args) {
    return this.axiosIns.delete(this.serviceConfig.adminBarcodePoolPurge, { data: args });
  }

  listBarcodeRangesAdmin(args) {
    return this.axiosIns.get(this.serviceConfig.adminBarcodeRanges, { params: args });
  }

  getBarcodeRangeAdmin(id) {
    return this.axiosIns.get(`${this.serviceConfig.adminBarcodeRanges}/${id}`);
  }

  listBarcodeRangeBarcodesAdmin(id, args) {
    return this.axiosIns.get(`${this.serviceConfig.adminBarcodeRanges}/${id}/barcodes`, {
      params: args
    });
  }

  deleteBarcodeRange(id) {
    return this.axiosIns.delete(`${this.serviceConfig.adminBarcodeRanges}/${id}`);
  }

  // Customer
  generateBarcodePoolCustomer(args) {
    return this.axiosIns.post(this.serviceConfig.customerBarcodePoolGenerate, args);
  }

  listBarcodeRangesCustomer(args) {
    return this.axiosIns.get(this.serviceConfig.customerBarcodeRanges, { params: args });
  }

  getBarcodeRangeCustomer(id) {
    return this.axiosIns.get(`${this.serviceConfig.customerBarcodeRanges}/${id}`);
  }

  listBarcodeRangeBarcodesCustomer(id, args) {
    return this.axiosIns.get(`${this.serviceConfig.customerBarcodeRanges}/${id}/barcodes`, {
      params: args
    });
  }
}
